import WebComponent from "webcomponent";
import template from "../html/view-overview.html";
import css from "../css/view-overview.css";

class ViewOverview extends WebComponent {
  static constructor() {
    customElements.define("fulljs-view-overview", ViewOverview);
  }
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static get schema() {
    return({
      "type": "object",
      "description": "Label Control displays text.",
      "properties": {
        "text": {
          "type": "string",
          "description": "Text content of the Label Control",
          "default": "Label #n"
        }
      }
    });
  }
  static get designer() {
    return({
      "category": "Basic",
      "icon": {"context": "actions", "size": 16, "iconname": "insert-text"}
    });
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));
    document.addEventListener("onupdatefermentations", this.onupdatefermentations_handler.bind(this));   
  }
  onupdatefermentations_handler(event) {
    var fermentations = event.detail;

    this.removeAttribute("inoculated");

    for (const fermentation of fermentations) {  
      if (fermentation.running && fermentation.inoculationDate) {
        this.setAttribute("inoculated", "");      
      }
    }
  }  
  stirringHover_click(event) {
    import("./dialog-config-steering.js").then(function(module) {
      new module.default();
    }).catch(function(result) {
      error(result);
    });
  }
  aerationHover_click(event) {
    import("../peripherals/iqflow/dialog-config-iqflow.js").then(function(module) {
      new module.default();
    }).catch(function(result) {
      error(result);
    });
  }
  temperatureHover_click(event) {
    import("../peripherals/ezo_rtd/dialog-config-ezortd.js").then(function(module) {
      new module.default();
    }).catch(function(result) {
      error(result);
    });
  }
  dissolvedOxygenHover_click(event) {
    import("../peripherals/ezo_do/dialog-config-ezodo.js").then(function(module) {
      new module.default();
    }).catch(function(result) {
      error(result);
    });
  }
  pHHover_click(event) {
    import("../peripherals/ezo_ph/dialog-config-ezoph.js").then(function(module) {
      new module.default();
    }).catch(function(result) {
      error(result);
    });
  }
  co2Hover_click(event) {
    import("../peripherals/gss_co2/dialog-config-co2.js").then(function(module) {
      new module.default();
    }).catch(function(result) {
      error(result);
    });
  }
  o2Hover_click(event) {
    import("../peripherals/mx200_o2/dialog-config-o2.js").then(function(module) {
      new module.default();
    }).catch(function(result) {
      error(result);
    });
  }
  async acidHover_click() {
    try {
      const module = await import("../dialogs/dialog-config-pump.js");
      new module.default({
        type: "acid"
      });
    } catch(e) {
      error(e);
    }
  }
  async baseHover_click() {
    try {
      const module = await import("../dialogs/dialog-config-pump.js");
      new module.default({
        type: "base"
      });
    } catch(e) {
      error(e);
    }
  }
  async feedHover_click() {
    try {
      const module = await import("../dialogs/dialog-config-pump.js");
      new module.default({
        type: "feed"
      });
    } catch(e) {
      error(e);
    }
  }
  impeller_click(event) {
    var popup = document.getElementById("myPopup");
    popup.classList.toggle("show");
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;
    
    if (devices.temperatureSensor)
      this.temp.innerHTML = devices.temperatureSensor.value;
    if (devices.ezortdSensor)
      this.temp.innerHTML = devices.ezortdSensor.value;
    
    if (devices.thermostat) {
      this.thermostatPWM.innerHTML = devices.thermostat.percentage;
      this.thermostatCurrent.innerHTML = devices.thermostat.current;
      this.thermostatVoltage.innerHTML = devices.thermostat.voltage;
      this.thermostatPower.innerHTML = devices.thermostat.power;
    }
    
    if (devices.dissolvedOxygenSensor)
      this.dissolvedOxygen.innerHTML = devices.dissolvedOxygenSensor.value;
    if (devices.ezodoSensor)
      this.dissolvedOxygen.innerHTML = devices.ezodoSensor.value;
    if (devices.visifermdo)
      this.dissolvedOxygen.innerHTML = devices.visifermdo.value;
    
    if (devices.pHSensor)
      this.pH.innerHTML = devices.pHSensor.value;
    if (devices.ezophSensor)
      this.pH.innerHTML = devices.ezophSensor.value;            
    if (devices.visifermph)
      this.pH.innerHTML = devices.visifermph.value;      
    
    if (devices.co2Sensor)
      this.co2.innerHTML = devices.co2Sensor.value;
    if (devices.ezoco2)
      this.co2.innerHTML = devices.ezoco2.value;
    if (devices.mx200co2)
      this.co2.innerHTML = devices.mx200co2.value;
    if (devices.gssco2)
      this.co2.innerHTML = devices.gssco2.value;

    if (devices.o2Sensor)
      this.o2.innerHTML = devices.o2Sensor.value;
    if (devices.ezoo2)
      this.o2.innerHTML = devices.ezoo2.value;
    if (devices.mx200o2)
      this.o2.innerHTML = devices.mx200o2.value;
    
    //this.co2.innerHTML = devices.co2Sensor&&!isNaN(devices.co2Sensor.value) ? devices.co2Sensor.value : "-";
    //this.co2.innerHTML = devices.co2Sensor&&!isNaN(devices.co2Sensor.value) ? devices.co2Sensor.value : (devices.ezoco2Sensor&&!isNaN(devices.ezoco2Sensor.value) ? devices.ezoco2Sensor.value : "-");
    //this.o2.innerHTML = devices.o2Sensor&&!isNaN(devices.o2Sensor.value) ? devices.o2Sensor.value : "-";
    //this.o2.innerHTML = devices.o2Sensor&&!isNaN(devices.o2Sensor.value) ? devices.o2Sensor.value : (devices.ezoo2Sensor&&!isNaN(devices.ezoo2Sensor.value) ? devices.ezoo2Sensor.value : "-");    

    let acidPump;
    if (devices.acidPump)
      acidPump = devices.acidPump;
    if (devices.ezoPumpAcid)
      acidPump = devices.ezoPumpAcid;
    if (devices.parallaxPumpAcid)
      acidPump = devices.parallaxPumpAcid;    
    
    if (acidPump)
      this.acid.innerHTML = Math.round(acidPump.mlh*10)/10;
    if (acidPump)
      this.acidSum.innerHTML = Math.round(parseFloat(acidPump.sumML)*10)/10;
    
    let basePump;
    if (devices.basePump)
      basePump = devices.basePump;
    if (devices.ezoPumpBase)
      basePump = devices.ezoPumpBase;
    if (devices.parallaxPumpBase)
      basePump = devices.parallaxPumpBase;    
    
    if (basePump)
      this.base.innerHTML = Math.round(basePump.mlh*10)/10;
    if (basePump)
      this.baseSum.innerHTML = Math.round(parseFloat(basePump.sumML)*10)/10;
    
    let feedPump;
    if (devices.feedPump)
      feedPump = devices.feedPump;
    if (devices.ezoPumpFeed)
      feedPump = devices.ezoPumpFeed;
    if (devices.parallaxPumpFeed)
      feedPump = devices.parallaxPumpFeed;
    
    
    if (feedPump)      
      this.feed.innerHTML = Math.round(feedPump.mlh*10)/10;
    if (feedPump)
      this.feedSum.innerHTML = Math.round(parseFloat(feedPump.sumML)*10)/10;
    
    this.stirring.innerHTML = Math.round(devices.stirring.rpm);
    
    if (devices.iqflow)
      this.aeration.innerHTML = isNaN(devices.iqflow.value) ? "-" : Math.round(devices.iqflow.value);
    if (devices.airflow)
      this.aeration.innerHTML = isNaN(devices.airflow.value) ? "-" : Math.round(devices.airflow.value);
    
/*    
    if (devices.thermostat.percentage==0) {
      this.peltier_1.style.fill = "#85b1c1";
      this.peltier_2.style.fill = "#85b1c1";      
    } else {
      if (devices.thermostat.mode==1) {
        this.peltier_1.style.fill = "red";
        this.peltier_2.style.fill = "red";
      } else {
        this.peltier_1.style.fill = "blue";
        this.peltier_2.style.fill = "blue";
      }
    }
*/    
/*
    var elements = this.shadowRoot.querySelectorAll('.bubble');
    for(var i=0; i<elements.length; i++){      
      elements[i].style.display = (devices.airflow && devices.airflow.value) ? "block" : "none";
      elements[i].style.display = (devices.airflow && devices.airflow.value) ? "block" : "none";      
    }
*/    
    this.setAttribute("stirring", Math.round(devices.stirring.rpm));
    this.setAttribute("aeration", devices.iqflow?Math.round(devices.iqflow.value):0);
    this.setAttribute("thermostat_pwm", devices.thermostat?.percentage);    
    this.setAttribute("thermostat_mode", devices.thermostat?.mode);    
  }
  set text(value) {
    this.textContent = value;
  }
  get text() {
    return(this.textContent);
  }
  toString() {
    return this.textContent;
  }
}

ViewOverview.constructor();

export default ViewOverview;